import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { finalize } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BeUtil, FeUtil } from '../../../hezky-routes';

interface TrainingVideo {
  serialNumber: string;
  title: string;
  description: string;
  fileLocation: string;
}

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-training-videos',
  templateUrl: './training-videos.component.html',
})
export class TrainingVideosComponent implements OnInit {
  @ViewChild('viewTicketModal', { static: true })
  viewResourceModal!: TemplateRef<any>;

  softwareVideos: TrainingVideo[] = [];
  hardwareVideos: TrainingVideo[] = [];
  resources: TrainingVideo | null = null;
  isTableLoading = false;
  paginationConfig: NzTableQueryParams = { pageIndex: 1, pageSize: 20, sort: [], filter: [] };
  activeTab: number = 0;

  constructor(
    protected _location: Location,
    private readonly beUtil: BeUtil,
    public feUtil: FeUtil,
  ) { }

  ngOnInit(): void { this.getDemoVideos() }

  protected getDemoVideos(): void {
    this.isTableLoading = true;
    this.beUtil.adminSvc.getDemoVideo()
      .pipe(untilDestroyed(this), finalize(() => this.isTableLoading = false))
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            const allVideos: TrainingVideo[] = response.data.map((item: any) => ({
              serialNumber: item.serialnumber,
              title: item.title,
              description: item.description,
              fileLocation: item.fileLocation
            }));
            const hardwareSerials = [23, 24, 25, 26];
            this.hardwareVideos = allVideos.filter(v => hardwareSerials.includes(Number(v.serialNumber)));
            this.softwareVideos = allVideos.filter(v => !hardwareSerials.includes(Number(v.serialNumber)));
          }
        }
      });
  }

  protected onTabChange(index: number): void {
    this.activeTab = index;
    this.paginationConfig = { ...this.paginationConfig, pageIndex: 1 }; // Reset page on tab change
  }

  protected onQueryParamsChange(params: NzTableQueryParams): void {
    this.paginationConfig = params;
  }

  protected viewTicket(data: TrainingVideo, tplContent: TemplateRef<any>): void {
    this.resources = data;
    this.feUtil.modalSvc.create({
      nzTitle: `Title: ${data.title}`,
      nzContent: tplContent,
      nzData: data,
      nzWidth: '70%',
      nzCloseOnNavigation: true,
      nzFooter: null,
      nzClosable: true,
      nzMaskClosable: false,
      nzCentered: true,
    });
  }
}
